<div class="button-wrap" [ngClass]="{ 'icon-only': !showMainButton }">
  <button *ngIf="showMainButton" class="btn" [ngClass]="{ 'btn-selected': isSelected() }" [ngStyle]="mainButtonStyle" (click)="onClick(data.key || data.label || data.type)">
    {{ displayLabel }}
  </button>

  <button *ngIf="isResetVisible" type="button" mat-icon-button class="reset-icon-btn" [style.height]="data?.iconHeight"
    [style.width]="data?.iconHeight" [style.margin-right]="data?.marginright" matTooltip="Reset filters"
    matTooltipPosition="above" (click)="onResetClick($event)">
    <svg class="filter-clear-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      <path d="M3.6 2.5h16.8c.9 0 1.4 1.02.85 1.73l-6.87 8.79v6.02a1 1 0 0 1-1.45.9l-3-1.5a1 1 0 0 1-.55-.9v-4.52L2.75 4.23c-.55-.71-.05-1.73.85-1.73z"/>
      <path d="M17.5 13.5a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm2.6 6.9-1.1 1.1-1.5-1.5-1.5 1.5-1.1-1.1 1.5-1.5-1.5-1.5 1.1-1.1 1.5 1.5 1.5-1.5 1.1 1.1-1.5 1.5z"/>
    </svg>
  </button>

  <button *ngIf="isInsightVisible" type="button" mat-icon-button class="insight-icon-btn"
    [style.height]="data?.iconHeight" [style.width]="data?.iconHeight" [matTooltip]="insightTooltipText"
    matTooltipClass="insight-tooltip-panel" matTooltipPosition="above" (click)="$event.stopPropagation()">
    <mat-icon>info</mat-icon>
  </button>
</div>
